'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PeerId = require('peer-id');
var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PeerId__default = /*#__PURE__*/_interopDefaultLegacy(PeerId);

function createWantlistForPeer({network}) {
  async function wantlistForPeer(peerId, options = {}) {
    const {bitswap} = await network.use(options);
    const list = bitswap.wantlistForPeer(PeerId__default["default"].createFromB58String(peerId));
    return Array.from(list).map(e => e[1].cid);
  }
  return withTimeoutOption.withTimeoutOption(wantlistForPeer);
}

exports.createWantlistForPeer = createWantlistForPeer;
